import { Component, OnInit } from '@angular/core';
import { SectionBase } from '../../../components/section/section-base';
import {SelectedOfferService} from '../../../../core/services/impl/section-services/selected-offer/selected-offer.service';
import {BannersService} from '../../../services/banners.service';
import {isCarOne, isNext} from '../../../../core/utils/utils';
import {
  NextOffersSectionStateService
} from '../../../../core/services/impl/section-services/next-offers/next-offers-section-state.service';
import {RegistrationService} from '../../../../core/services/impl/registration.service';

@Component({
  selector: 'app-selected-offer-section',
  templateUrl: './selected-offer-section.component.html',
  styleUrls: ['./selected-offer-section.component.scss']
})
export class SelectedOfferSectionComponent extends SectionBase implements OnInit {

  isNext = isNext();
  isCarOne: boolean = isCarOne();

  get bannerVisible(): boolean {
    return this.bannersService.paymentBannerVisible && !this.selectedOfferService.hasModifications;
  }

  constructor(public selectedOfferService: SelectedOfferService,
              public offersSectionStateService: NextOffersSectionStateService,
              private bannersService: BannersService,
              private registrationService: RegistrationService) {
    super();
  }

  ngOnInit() {
    if (isCarOne()) {
      this.registrationService.offerId = this.selectedOfferService.selectedOffer.id;
    }
    this.handleOfferStatus();
  }

  initBean() {
  }

  initControlsChanges() {
  }

  createConfig() {
  }

  isSectionValid(): boolean {
    return true;
  }

  submitSection(): void {
  }

  get valid(): boolean {
    return true;
  }

  private handleOfferStatus(): void {
    if (this.offersSectionStateService.shouldReconnectWebsocketForGetOffer) {
      this.offersSectionStateService.reconnectWebsocketForGetOffer();
    }
  }
}
